var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"tabs"},_vm._l((_vm.formattedTabs),function(item,index){return _c('div',{key:index,class:{ active: item.active },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(_vm._s(item.title))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }